import RemoteSelect from "common/components/RemoteSelect/RemoteSelect";
import usePark from "common/hooks/usePark";
// import { Genus } from "types/Genus";

const processOptions = (options: any[]) =>
  options.map(({ id, name }) => ({
    value: id,
    label: name,
  }));

function GenusSelect(props: any) {
  const { park } = usePark();

  return (
    <RemoteSelect
      url="genera"
      processOptions={processOptions}
      filters={[{ name: "park", value: park?.id }]}
      {...props}
    />
  );
}

export default GenusSelect;
